<h1 mat-dialog-title>Seleziona un Rider</h1>

<div mat-dialog-content>
    <table mat-table [dataSource]="riders$" class="mat-elevation-z8">
        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Nome </th>
            <td mat-cell *matCellDef="let rider"> {{ rider.name }} </td>
        </ng-container>

        <ng-container matColumnDef="surname">
            <th mat-header-cell *matHeaderCellDef> Cognome </th>
            <td mat-cell *matCellDef="let rider"> {{ rider.surname }} </td>
        </ng-container>

        <ng-container matColumnDef="phone">
            <th mat-header-cell *matHeaderCellDef> Telefono </th>
            <td mat-cell *matCellDef="let rider"> {{ rider.phone }} </td>
        </ng-container>

        <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef> Email </th>
            <td mat-cell *matCellDef="let rider"> {{ rider.email }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onSelect(row)" [class.selected]="selectedRider?.id === row.id"></tr>
    </table>
</div>

<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="onClose()" color="primary">Chiudi</button>
  <!-- <button mat-raised-button *ngIf="selectedRider" (click)="onClose()">Annulla</button> -->
  <button mat-raised-button *ngIf="selectedRider" (click)="confirmSelection()">Conferma</button>
</div>
